<template>
  <input
    :placeholder="placeholder"
    :type="type"
    :value="value"
    @input="$emit('input', $event.target.value)"
    class="border border-black rounded border-gray-200 border px-4 py-1.5 hover:border-gray-300 focus:outline-none focus:border-gray-300"
  />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search'
    }
  }
}
</script>
